import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ScienceIcon from "@mui/icons-material/Science";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import swanAiLogo from "../../assets/fig_agent.png";

const Sidebar = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <Box
            sx={{
                "& .pro-sidebar-inner": {
                    background: "#fff !important",
                    color: "#333 !important",
                },
                "& .pro-icon-wrapper": { backgroundColor: "transparent !important" },
                "& .pro-inner-item": {
                    padding: "10px 20px !important",
                    borderRadius: "4px",
                    margin: "6px 8px",
                },
                "& .pro-inner-item:hover": {
                    color: "#1976d2 !important",
                    backgroundColor: "rgba(25, 118, 210, 0.07) !important",
                },
                "& .pro-menu-item.active": {
                    color: "#1976d2 !important",
                    fontWeight: "bold",
                    backgroundColor: "rgba(25, 118, 210, 0.1) !important",
                },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "100vh",
                width: isCollapsed ? "80px" : "260px",
                transition: "width 0.3s ease-in-out",
            }}
        >
            <ProSidebar collapsed={isCollapsed}>
                <Menu iconShape="square">
                    {/* Collapse Button */}
                    <MenuItem
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        icon={<MenuOutlinedIcon />}
                        style={{
                            margin: "10px 0 20px 0",
                            color: "#333",
                        }}
                    />

                    {/* FIG Agent Logo */}
                    <Box
                        mb="20px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            width: "100%",
                            padding: "10px",
                        }}
                    >
                        <img
                            src={swanAiLogo}
                            alt="Swan AI Labs"
                            style={{
                                width: isCollapsed ? "50px" : "90px",
                                height: isCollapsed ? "50px" : "90px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                transition: "width 0.3s ease-in-out, height 0.3s ease-in-out",
                            }}
                        />
                    </Box>

                    {/* Sandbox Items */}
                    <MenuItem icon={<ScienceIcon />} style={{ color: "#333" }}>
                        <Link to="/sandbox" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>FIG Agent Sandbox</Typography>
                    </MenuItem>
                    <MenuItem icon={<FastfoodIcon />} style={{ color: "#333" }}>
                        <Link to="/usda-fdc" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>USDA FDC</Typography>
                    </MenuItem>
                    <MenuItem icon={<FastfoodIcon />} style={{ color: "#333" }}>
                        <Link to="/usda-fbg" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>AI USDA Buying Guide</Typography>
                    </MenuItem>
                    <MenuItem icon={<ShoppingCartIcon />} style={{ color: "#333" }}>
                        <Link to="/gdsn-products" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>GDSN Products</Typography>
                    </MenuItem>
                    <MenuItem icon={<ShoppingCartIcon />} style={{ color: "#333" }}>
                        <Link to="/sail-partnerhub" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>Partner Hub - Canvas</Typography>
                    </MenuItem>
                    <MenuItem icon={<ScienceIcon />} style={{ color: "#333" }}>
                        <Link to="/bulk-invoice" style={{ textDecoration: "none", color: "inherit" }} />
                        <Typography>AI Bulk Invoice Review</Typography>
                    </MenuItem>

                    {/* Back to FIG Link */}
                    <MenuItem
                        icon={<ArrowBackIcon />}
                        style={{ color: "#333" }}
                        onClick={() => window.open("https://figk-12.com", "_blank")}
                    >
                        <Typography>Back to FIG</Typography>
                    </MenuItem>
                </Menu>
            </ProSidebar>
        </Box>
    );
};

export default Sidebar;
